/**
 *  展会配置api
 */
const hostMedia = 'eventsgo/media/'
// 展会配置首页列表
export const GET_EXHI_INDEX_LIST = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/findExhibitionConfigPagedList'
// 修改展会推荐开关
export const CHANGE_EXHI_SWITCH = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/checkExhibitionRecommended'
// 修改展会是否可见
export const CHANGE_EXHI_VISIBLE = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/updateExhiIsShow'
// 弹出cims展会收索页
export const SEARCH_CIMS_EXHI_LIST = hostMedia + 'services/eventsgo/public/exhiForAshService/eventsgo-manageapi/findExhiInfoList'
export const ADD_EXHI = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/addExhibition'
export const EDIT_EXHI = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/updateExhibition'
// 请求编辑展会信息
export const GET_EDIT_EXHI_INFO = hostMedia + 'services/eventsgo/public/exhibitions/eventsgo-manageapi/findExhibition'
// 展会是否可见 lookUp
export const GET_IS_VISIBLE = hostMedia + 'services/eventsgo/public/lookupService/list?classifyCode=IS_SHOW'
// cims 展会详情
export const GET_CIMS_EXHI_DETAIL = hostMedia + 'services/eventsgo/public/exhiForAshService/eventsgo-manageapi/findExhiDetails'
// 展会配置列表导出
export const EXPORT_LIST = hostMedia + 'services/eventsgo/public/excel/export/eventsgo-manageapi/exhibitionConfigExport'
